import { ReduxState } from '../../types';

// eslint-disable-next-line import/prefer-default-export
export const favoritesListSelector = (state: ReduxState) => state.userFavorites.defaultList;
export const favoritesListsSelector = (state: ReduxState) => state.userFavorites.lists;
